import { render, staticRenderFns } from "./AgendaConfirmations.vue?vue&type=template&id=6d5b5596&"
import script from "./AgendaConfirmations.vue?vue&type=script&lang=js&"
export * from "./AgendaConfirmations.vue?vue&type=script&lang=js&"
import style0 from "./AgendaConfirmations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports